/**
 * Placeholder for the hosted web SPA. Full product UI lives in the Chrome extension build.
 */
export default function WebMockPage() {
    return (
        <div className="min-h-screen bg-gray-950 text-white flex flex-col items-center justify-center p-8">
            <h1 className="text-2xl font-bold mb-2">Warranty Copilot (web)</h1>
            <p className="text-gray-400 text-center max-w-md">
                This is a mock page for the static web build. The primary experience is the browser
                extension (side panel + WarrQueue integration).
            </p>
        </div>
    );
}
